import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import React from 'react';
import {
  individual_column_style,
  individual_header_style
} from 'assets/styles/table_custom_style';
import { DatesHelper } from 'utils/classes/DatesHelper';
import FlexTable from 'components/FlexTable';
import { toBrazilianFullDate } from 'views/CRM/shared/utils/date';
import { PhoneCell } from 'components/FlexTable/components/cells/phone';

export const Analytical = ({
  data,
  customFields,
  reportType,
  setSortConfig,
  sortConfig
}) => {
  const createDynamicColumns = () => {
    const columns = [];

    columns.push(
      {
        dataField: 'name',
        text: 'Nome',
        sort: true,
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' }
      },
      {
        dataField: 'telephone',
        text: 'Telefone',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (cell, row) => {
          if (!cell) return null;
          return <PhoneCell phone={cell} ddi={row?.ddi} />;
        }
      },
      {
        dataField: 'stage_name',
        text: 'Fase do Lead',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { stageName }) => stageName
      },
      {
        dataField: 'created_at',
        text: 'Criado em',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { createdAt }) => toBrazilianFullDate(createdAt)
      },
      {
        dataField: 'created_by',
        text: 'Criado por',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { createdByName }) => createdByName
      },
      {
        dataField: 'responsible',
        text: 'Responsável',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { responsibleName }) => responsibleName
      },
      {
        dataField: 'last_updated_at',
        text: 'Última atualização',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { lastUpdatedAt }) =>
          DatesHelper.convertDateObjectToBrazilianFormat(
            new Date(lastUpdatedAt)
          )
      },
      {
        dataField: 'converted_at',
        text: 'Data da conversão',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { convertedAt }) =>
          DatesHelper.convertDateObjectToBrazilianFormat(new Date(convertedAt))
      },
      {
        dataField: 'converted_time',
        text: 'Tempo conversão',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { convertedAt }) =>
          DatesHelper.getTimeFromDate(new Date(convertedAt))
      },
      {
        dataField: 'month_quantity',
        text: 'Quantidade de meses',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { monthQuantity }) => monthQuantity
      }
    );

    (customFields || []).forEach((field) => {
      if (field.label === 'Origem do Lead')
        columns.push({
          dataField: field.name,
          text: field.label,
          style: individual_column_style,
          formatter: (_, row) => {
            return row[`${field.name}`];
          }
        });
    });

    columns.push(
      {
        dataField: reportType === '2' ? 'date_closed_won' : 'date_closed_lost',
        text: 'Data do Fechamento',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (cell) =>
          cell
            ? DatesHelper.convertDateObjectToBrazilianFormat(new Date(cell))
            : null
      },
      {
        dataField: 'opportunity_stage_name',
        text: 'Fase da Oportunidade',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { opportunityStageName }) => opportunityStageName
      },
      {
        dataField: 'closed_time',
        text: 'Tempo Fechamento',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { dateClosedLost }) => dateClosedLost
      },
      {
        dataField: 'month_closed_quantity',
        text: 'Quantidade de Meses Fechamento',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' }
      },
      {
        dataField: 'opportunity_responsible',
        text: 'Responsável da Oportunidade',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { opportunityResponsible }) => opportunityResponsible
      }
    );

    return [...columns];
  };

  const dynamicFunctionColumns = createDynamicColumns();

  return (
    <ToolkitProvider
      data={data || []}
      keyField="id"
      columns={dynamicFunctionColumns}
    >
      {(props) => (
        <div className="py-4 table-responsive">
          <FlexTable
            {...props.baseProps}
            entityName="leadsConvertion"
            setSortConfig={setSortConfig}
            sortConfig={sortConfig}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};
